import { gql } from '@apollo/client';

export const TOGGLE_GROUP_ATTENDEES_IN_ACTIVITY = gql`
  mutation toggleGroupAttendeesInActivity($input: ToggleGroupAttendeesInput!) {
    activity: toggleGroupAttendeesInActivity(input: $input) {
      id
    }
  }
`;
